export const baseURL =
  process.env.REACT_APP_ENV === 'prod'
    ? 'https://opticus-prod-n5sgydzbyq-uc.a.run.app/api/'
    // : 'https://opticus-axv7ze2qva-uc.a.run.app/api/';
    : 'http://localhost:3002/api/';
